<template>
    <div class="h-100 wrapper">
<!--        <ElderHeader/>-->
        <div class="outer-container mx-auto">
            <v-row class="empty">
                <v-col cols="3" class="back-box">
                    <img src="../../../../../../assets/svg/backIcon.svg" alt="">
                </v-col>
                <v-col cols="9" class="empty-box">
                    <div class="d-lg-flex justify-space-around user-input">
                        <v-text-field
                                class="text-field"
                                v-model="search"
                                prepend-inner-icon="mdi-magnify"
                                single-line
                                label="Search for keyword"
                                @change="onSearchInputChange"
                        ></v-text-field>
                        <FilterModal/>
                        <InfoSessionModal/>
                        <v-select
                                class="text-field"
                                :items="numberList"
                                outlined
                                :dense="true"
                                v-model="select"
                                item-text="text"
                                item-value="value"
                                return-object
                                @change="setItemsPerPage"
                        ></v-select>
                    </div>
                </v-col>
            </v-row>
            <v-row class="dashboard-container">
                <v-col cols="3" class="side-menu">
                    <DashboardSideMenu/>
                </v-col>
                <v-col cols="9" class="table-col">
                    <ApplicantsTable
                            :applicants="allApplicants"
                            :is-loading="isLoading"
                            :search="search"
                            :itemsPerPage="itemsPerPage"
                            :headers="headers"
                    />
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
import DashboardSideMenu from "./DashboardSideMenu";
import ApplicantsTable from "./ApplicantsTable";
// import ElderHeader from "../../ElderHeader";
import {mapActions, mapGetters} from 'vuex'
import InfoSessionModal from "./InfoSessionModal";
import FilterModal from "./FilterModal";

export default {
  name: "DashboardView",
  components: {
    FilterModal,
    // ElderHeader,
    ApplicantsTable,
    DashboardSideMenu,
    InfoSessionModal
  },
  data: () => ({
    search: '',
            itemsPerPage: 30,
            select: {
                text: 'Show 30',
                value: 30,
            },
            numberList: [
                {
                    text: 'Show 5',
                    value: 5,
                },
                {
                    text: 'Show 10',
                    value: 10,
                },
                {
                    text: 'Show 15',
                    value: 15,
                },
                {
                    text: 'Show 20',
                    value: 20,
                },
                {
                    text: 'Show 25',
                    value: 25,
                },
                {
                    text: 'Show 30',
                    value: 30,
                }
            ]
        }),
        created() {
            this.fetchAllApplicants()
            this.search = this.currentTableState.search
            this.select.value = this.currentTableState.itemsPerPage
            if (!this.isLoading) this.filterApplicants(this.filterConditions)
        },
        methods: {
            ...mapActions([
                'fetchAllApplicants',
                'setCurrentTableState',
                'setDisplayList',
                'setAllApplicants',
                'filterApplicants',
            ]),
            setItemsPerPage() {
                this.itemsPerPage = this.select.value
                this.setCurrentTableState({key: 'itemsPerPage', value: this.select.value})
            },
            onSearchInputChange() {
                this.setCurrentTableState({key: 'search', value: this.search})
            }
        },
        computed: {
            ...mapGetters([
                'allApplicants',
                'isLoading',
                'headers',
                'currentTableState',
                'filterConditions'
            ]),
        }
    }
</script>

<style scoped>
    .wrapper {
        background: #F6F6F6;
    }

    .outer-container {
        background: #FFF !important;
        border-radius: 10px;
        width: 95% !important;
        box-shadow: 0 15px 30px rgba(130, 130, 130, 0.15);
        padding: 0 !important;
        margin-bottom: 20px;
      height: calc(100vh - 120px);
    }

    .empty {
        width: 100% !important;
        margin: 0 auto;
        max-height: 63px !important;
    }

    .dashboard-container {
        width: 100% !important;
        margin: 0 auto;
        background: #FFF;
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
    }

    .table-col {
        border-left: 1px solid rgba(130, 130, 130, 0.15);
        border-top: 1px solid rgba(130, 130, 130, 0.15);
        padding-right: 0 !important;
        padding-bottom: 0 !important;
        padding-left: 0 !important;
        flex: 0 0 80%;
        max-width: 80%;
        /*height: 509px;*/
        /*overflow-y: scroll;*/
    }

    .table-col::-webkit-scrollbar {
        background: transparent;
        width: 10px;
        height: 20px;
    }

    .table-col::-webkit-scrollbar-thumb {
        background: rgba(43, 28, 28, 0.2);
        max-height: 20px !important;
        height: 20px !important;
        border-radius: 12px;
    }

    .back-box {
        padding-right: 0 !important;
        max-width: 20% !important;
        flex: 0 0 20% !important;
    }

    .empty-box {
        border-left: 1px solid rgba(130, 130, 130, .15);
        padding-left: 0 !important;
    }

    .side-menu {
        border-top: 1px solid rgba(130, 130, 130, .15);
        padding-right: 0 !important;
        max-width: 20% !important;
        flex: 0 0 20% !important;
    }

    .text-field:first-child {
        padding: 0 !important;
        max-width: 200px !important;
    }

    .user-input .v-select {
        padding: 0 !important;
        max-width: 125px !important;
    }
</style>